module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-suche__page--wrapper"
  }, [_c('div', {
    staticClass: "ksm-suche__page"
  }, [_c('div', {
    staticClass: "ksm-suche__content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeys),
      expression: "searchKeys"
    }],
    staticStyle: {
      "width": "50em",
      "padding": "5px"
    },
    attrs: {
      "type": "text",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.searchKeys)
    },
    on: {
      "keydown": _vm.actionKeydown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeys = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "padding": "5px"
    },
    on: {
      "click": _vm.searchStart
    }
  }, [_vm._v("Suche")]), _vm._v(" "), (_vm.showLoading) ? _c('g-loading', {
    attrs: {
      "size": "mini"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.resultText))]), _vm._v(" "), (_vm.resultList) ? _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._l((_vm.resultList), function(it, i) {
    return [_c('div', {
      key: i,
      staticClass: "ksm-flex-1",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(it.merz.name.trim().replace('Merz', 'Merz ')))]), _vm._v(" "), _vm._l((it.seitenData), function(it2, pi2) {
      return [_c('div', {
        key: 's' + pi2
      }, [_vm._v(_vm._s(it2.seite.name.length > 20 ? it2.seite.name : it2.seite.name.replace(/\s/g, '')))]), _vm._v(" "), _vm._l((it2.hls), function(hl, hli) {
        return _c('div', {
          key: 'h' + hli + '-' + pi2,
          staticStyle: {
            "padding": "0 2em"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.toPath(it, it2, hl.key)
            }
          }
        }, [_vm._v(_vm._s(hl.type))]), _vm._v(" "), _c('span', {
          staticClass: "ksm-suche-hl",
          domProps: {
            "innerHTML": _vm._s(hl.val)
          }
        })])
      })]
    })], 2)]
  })], 2) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e754a0e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Suche.vue
// module id = 1969
// module chunks = 1